
const infoBtn = document.getElementById('info-btn');
const detBtn = document.getElementById('det-btn');
const addinfo = document.getElementById('add-info');
const allDetail = document.getElementById('all-detail');

if (infoBtn && detBtn && addinfo && allDetail) {
    infoBtn.onclick = () => {
        addinfo.style.display = "block";
        allDetail.style.display = "none";
        infoBtn.classList.add('active-ct');
        detBtn.classList.remove('active-ct');
    };

    detBtn.onclick = () => {
        allDetail.style.display = "block";
        addinfo.style.display = "none";
        detBtn.classList.add('active-ct');
        infoBtn.classList.remove('active-ct');
    };
}


const selectMenu = document.getElementById('selectMenu');
const clearButton = document.getElementById('clearButton');
const contentDiv = document.getElementById('content');

if (selectMenu && clearButton && contentDiv) {
    function handleSelectChange() {
        if (selectMenu.value !== '0') {
            contentDiv.style.display = 'block';
            clearButton.style.visibility = 'visible';
        } else {
            contentDiv.style.display = 'none';
            clearButton.style.visibility = 'hidden';
        }
    }

    function handleClearClick() {
        selectMenu.value = '0';
        contentDiv.style.display = 'none';
        clearButton.style.visibility = 'hidden';
    }

    selectMenu.addEventListener('change', handleSelectChange);
    clearButton.addEventListener('click', handleClearClick);
}



const zoomBtn = document.querySelector('.zoom-icon');
const mainSlider = document.querySelector('.slider-side');
const bgFtElements1 = document.querySelectorAll('.bg-ft');
const ziImgElements = document.querySelectorAll('.zi-img');
const closeSd = document.querySelector('.close-sd');

if (zoomBtn && mainSlider && bgFtElements1 && ziImgElements && closeSd) {
    zoomBtn.onclick = () => {
        mainSlider.classList.add('big-slider');
        bgFtElements1.forEach((bgFtElement) => {
            bgFtElement.classList.remove('zi-img');
        });
    };

    closeSd.onclick = () => {
        mainSlider.classList.remove('big-slider');
        bgFtElements1.forEach((bgFtElement) => {
            bgFtElement.classList.add('zi-img');
        });
    };

    ziImgElements.forEach((ziImgElement) => {
        ziImgElement.onclick = () => {
            ziImgElement.classList.toggle('zoom-img');
        };
    });
}


const bgFtElements = document.querySelectorAll('.bg-ft');
const zoomIcon = document.querySelector('.zoom-img-icon');
let isZoomed = false;

if (zoomIcon && bgFtElements) {
    zoomIcon.addEventListener('click', () => {
        isZoomed = !isZoomed;
        bgFtElements.forEach((bgFtElement) => {
            bgFtElement.classList.toggle('zoom-img', isZoomed);
        });
    });

    bgFtElements.forEach((bgFtElement) => {
        bgFtElement.addEventListener('click', (event) => {
            event.stopPropagation();
            isZoomed = !isZoomed;
            bgFtElement.classList.toggle('zoom-img', isZoomed);
        });
    });
}


const containers = document.querySelectorAll('.zoom-image');

if (containers) {
    const moveImage = (event, image) => {
        const { offsetX, offsetY } = event;
        const { width, height } = image.getBoundingClientRect();

        const x = (offsetX / width) * 200;
        const y = (offsetY / height) * 200;

        image.style.transformOrigin = `${x}% ${y}%`;
    };

    const handleZoom = (event) => {
        const image = event.currentTarget.querySelector('.zi-img');
        image.style.transform = 'scale(2)';
        moveImage(event, image);
    };

    const handleResetZoom = (event) => {
        const image = event.currentTarget.querySelector('.zi-img');
        image.style.transform = 'scale(1)';
    };

    containers.forEach((container) => {
        container.addEventListener('mousemove', (event) => handleZoom(event));
        container.addEventListener('mouseleave', (event) => handleResetZoom(event));
    });
}


var swiper7 = null; // Declare swiper7 variable for later assignment

// Validation for Swiper initialization
if (document.querySelector(".mySwiper7")) {
    swiper7 = new Swiper(".mySwiper7", {
        spaceBetween: 0,
        slidesPerView: 5,
        watchSlidesProgress: true,
    });
}

const imageSelect = document.getElementById('selectMenu');
var swiper6 = null; // Declare swiper6 variable for later assignment

// Validation for Swiper initialization and imageSelect element
if (imageSelect && swiper7) {
    swiper6 = new Swiper(".mySwiper6", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper7,
        },
    });

    imageSelect.addEventListener('change', () => {
        const selectedSlideIndex = parseInt(imageSelect.value);
        swiper6.slideTo(selectedSlideIndex);
    });
}

